(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anakara-best-sellers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope = document) => {
      scope.querySelectorAll('[data-anakara-best-sellers]').forEach((root) => {
        if (root.dataset.bestReady === 'true') return;
        root.dataset.bestReady = 'true';

        const track = root.querySelector('[data-anakara-best-track]');
        const previous = root.querySelector('[data-anakara-best-prev]');
        const next = root.querySelector('[data-anakara-best-next]');
        const progress = root.querySelector('[data-anakara-best-progress]');

        if (!track || !previous || !next) return;

        const update = () => {
          const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
          const ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
          const visibleRatio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;

          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maxScroll - 2;

          if (progress) {
            const base = visibleRatio * 100;
            const width = Math.min(100, base + ratio * (100 - base));
            progress.style.width = width + '%';
          }
        };

        const move = (direction) => {
          const amount = Math.max(track.clientWidth * 0.78, 260);
          track.scrollBy({ left: amount * direction, behavior: 'smooth' });
        };

        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);

        update();
      });
    };

    init();

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anakara-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (scope = document) => {
      scope.querySelectorAll('[data-anakara-footer]').forEach((footer) => {
        if (footer.dataset.footerReady === 'true') return;
        footer.dataset.footerReady = 'true';

        const menus = Array.from(footer.querySelectorAll('[data-footer-menu]'));
        const mobile = window.matchMedia('(max-width: 749px)');

        const syncMenus = () => {
          menus.forEach((menu) => {
            menu.open = !mobile.matches;
          });
        };

        syncMenus();
        mobile.addEventListener('change', syncMenus);
      });
    };

    setup();

    document.addEventListener('shopify:section:load', (event) => {
      setup(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anakara-home-hero"] && !Shopify.designMode) return;
  try {
    
  class AnakaraHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.timer = null;

      if (this.slides.length < 2) return;

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1, true));

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.show(index, true));
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(index, userInitiated = false) {
      const count = this.slides.length;
      this.index = (index + count) % count;

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.index;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (userInitiated) {
        this.stop();
        this.start();
      }
    }

    start() {
      this.stop();
      if (this.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const speed = Number(this.dataset.speed) || 6000;
      this.timer = window.setInterval(() => this.show(this.index + 1), speed);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('anakara-hero')) {
    customElements.define('anakara-hero', AnakaraHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anakara-product-info-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProductGuide = (scope = document) => {
      scope.querySelectorAll('[data-anakara-product-guide]').forEach((root) => {
        if (root.dataset.productGuideReady === 'true') return;
        root.dataset.productGuideReady = 'true';

        const tabs = Array.from(root.querySelectorAll('[data-anakara-guide-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-anakara-guide-panel]'));

        const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;

        const activateDesktopPanel = (key, focusTab = false) => {
          if (!isDesktop()) return;

          tabs.forEach((tab) => {
            const active = tab.dataset.anakaraGuideTab === key;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;

            if (active && focusTab) tab.focus();
          });

          panels.forEach((panel) => {
            panel.open = panel.dataset.anakaraGuidePanel === key;
          });
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            activateDesktopPanel(tab.dataset.anakaraGuideTab);
          });

          tab.addEventListener('keydown', (event) => {
            if (!isDesktop()) return;

            let nextIndex = null;

            if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
              nextIndex = (index + 1) % tabs.length;
            } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
              nextIndex = (index - 1 + tabs.length) % tabs.length;
            } else if (event.key === 'Home') {
              nextIndex = 0;
            } else if (event.key === 'End') {
              nextIndex = tabs.length - 1;
            }

            if (nextIndex === null) return;

            event.preventDefault();
            activateDesktopPanel(tabs[nextIndex].dataset.anakaraGuideTab, true);
          });
        });

        panels.forEach((panel) => {
          panel.addEventListener('toggle', () => {
            if (!isDesktop() || !panel.open) return;
            const key = panel.dataset.anakaraGuidePanel;
            activateDesktopPanel(key);
          });
        });

        const syncMode = () => {
          if (isDesktop()) {
            const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
            if (activeTab) activateDesktopPanel(activeTab.dataset.anakaraGuideTab);
          }
        };

        window.addEventListener('resize', syncMode, { passive: true });
        syncMode();
      });
    };

    initProductGuide();

    document.addEventListener('shopify:section:load', (event) => {
      initProductGuide(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anakara-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope = document) => {
      scope.querySelectorAll('[data-anakara-product-tabs]').forEach((root) => {
        if (root.dataset.tabsReady === 'true') return;
        root.dataset.tabsReady = 'true';

        const tabs = Array.from(root.querySelectorAll('[data-anakara-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-anakara-panel]'));

        const activateTab = (tab, focus = false) => {
          tabs.forEach((item) => {
            const selected = item === tab;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-selected', selected ? 'true' : 'false');
            item.tabIndex = selected ? 0 : -1;
          });

          panels.forEach((panel) => {
            panel.hidden = panel.id !== tab.getAttribute('aria-controls');
          });

          if (focus) tab.focus();
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activateTab(tab));

          tab.addEventListener('keydown', (event) => {
            let nextIndex = null;

            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;

            if (nextIndex === null) return;
            event.preventDefault();
            activateTab(tabs[nextIndex], true);
          });
        });

        root.querySelectorAll('[data-anakara-load-more]').forEach((button) => {
          button.addEventListener('click', () => {
            const panel = button.closest('[data-anakara-panel]');
            if (!panel) return;

            const hiddenCards = Array.from(panel.querySelectorAll('[data-anakara-product-card][hidden]'));
            const step = Number.parseInt(panel.dataset.step || '4', 10);
            hiddenCards.slice(0, step).forEach((card) => {
              card.hidden = false;
            });

            if (panel.querySelectorAll('[data-anakara-product-card][hidden]').length === 0) {
              button.hidden = true;
            }
          });
        });
      });
    };

    init();

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
